import {connect} from 'react-redux';
import BaseTab from './BaseTab';
import { setTransactionsKiosk } from '../../redux/actions';

class KioskTab extends BaseTab {

  onPageChange = (event, { activePage }) => {
    this.props.setTransactionsKiosk({ grid: {...this.props.data.grid, pageNumber: activePage }}).then(this.props.onRefresh)
  }

}

const mapStateToProps = state => {
	return {
    data: state.transactionsKiosk,
  };
};


export default connect(mapStateToProps, { setTransactionsKiosk })(KioskTab);